import React, { useEffect, useState } from "react";
import { gql, useLazyQuery } from "@apollo/client";
import { Skeleton, Drawer, Space } from "antd";
import { useParams } from "react-router-dom";
import OtherErrors from "@general/otherErrors";
import moment from "moment-jalaali";
import AdminInvoicesListTable from "./table";
import UserInvoicesTableDetails from "./tableDetails";
import TableFilters from "@general/tableFilters";
import getWindowSize from "@utils/windowSize";

const GETINVOICES = gql`
  query ($paginateInput: PaginateInput!, $searchInput: InvoiceSearchInput!) {
    getInvoicesCount(searchInput: $searchInput)
    getInvoices(paginateInput: $paginateInput, searchInput: $searchInput) {
      id
      createdAt
      updatedAt
      paidAt
      cancelAt
      amountRial
      discountAmount
      discountCode
      finalAmount
      description
      invoiceType
      user {
        gender
        name
      }
    }
  }
`;
function UsersInvoices(props) {
  const [tableData, setTableData] = useState({});
  const [currentPage, setCurrentPage] = useState();
  const [sortDir, setSortDir] = useState("desc");
  const [sortColumn, setSortColumn] = useState("createdAt");
  const [filterDateFrom, setFilterDateFrom] = useState(null);
  const [filterDateTo, setFilterDateTo] = useState(null);
  const [filterSearchPhrase, setFilterSearchPhrase] = useState("");
  const [drawer, setDrawer] = useState(false);
  const windowSize = getWindowSize().innerWidth;

  const [getInvoices, invoices] = useLazyQuery(GETINVOICES, {
    fetchPolicy: "no-cache",
    onCompleted(data) {
      setTableData(data);
    },
  });
  const { result } = useParams();
  useEffect(() => {
    getInvoices({
      variables: {
        paginateInput: {
          page: currentPage,
          perPage: 10,
          sort: sortColumn && sortColumn,
          sortDir: sortDir,
        },
        searchInput: {
          userId: result !== "all" ? result : null,
          createdAt:
            filterDateFrom && filterDateTo
              ? [filterDateFrom, filterDateTo]
              : null,
          textSearch: filterSearchPhrase,
        },
      },
    });
  }, [currentPage, sortDir, filterDateTo, filterSearchPhrase]);

  const pageChange = (current) => {
    setCurrentPage(current);
  };

  const sort = (sortData) => {
    setCurrentPage(1);
    setSortColumn(sortData.columnKey);
    if (sortData.order === "ascend") setSortDir("asc");
    if (!sortData.order || sortData.order === "descend") setSortDir("desc");
  };

  const filterDate = (dates, dateString) => {
    setCurrentPage(1);
    if (dateString[0] === "" || dateString[1] === "") {
      setFilterDateFrom(null);
      setFilterDateTo(null);
    } else {
      setFilterDateFrom(
        moment(dateString[0], "jYYYY/jMM/jDD")
          .startOf("day")
          .toDate()
          .toISOString()
      );
      setFilterDateTo(
        moment(dateString[1], "jYYYY/jMM/jDD")
          .endOf("day")
          .toDate()
          .toISOString()
      );
    }
  };

  const filterSearch = (phrase) => {
    setCurrentPage(1);
    setFilterSearchPhrase(phrase);
  };

  const openDrawer = (id) => {
    setDrawer({ id });
  };
  const closeDrawer = () => {
    setDrawer(false);
  };

  if (invoices.error) return <OtherErrors />;
  if (Object.keys(tableData).length === 0)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  return (
    <>
      <Drawer
        title="جزییات فاکتور"
        placement="right"
        open={drawer}
        onClose={closeDrawer}
        size={windowSize >= 750 ? "large" : null}
        width={windowSize < 750 ? windowSize - 50 : null}
      >
        <UserInvoicesTableDetails invoiceId={drawer.id} />
      </Drawer>

      <TableFilters onFilterDate={filterDate} onFilterSearch={filterSearch} />
      <Space></Space>
      <br />
      <AdminInvoicesListTable
        data={tableData}
        onSort={sort}
        onPageChange={pageChange}
        currentPage={currentPage}
        loading={invoices.loading}
        onOpenDrawer={openDrawer}
      />
    </>
  );
}

export default UsersInvoices;
